import { useMutation, useQueryClient } from "react-query";
import { addPaymentRemittanceType } from "../../../../../actions/Utilities/PaymentRemittanceType";
import { PaymentRemittanceTypeInfo } from "../types";
import { toast } from "../../../../../components/toastNotification";

const useAddPaymentRemittanceType = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (paymentRemittanceTypeNewData: PaymentRemittanceTypeInfo) => addPaymentRemittanceType(paymentRemittanceTypeNewData),
    {
      onSuccess: (res: any) => {
        if (res === "Duplicate") {
          toast.fire("Saving Failed", "The data already exists!", "error");
        } else {
          queryClient.invalidateQueries(["GetPaymentRemittanceType"]);
          toast.fire("Success", "Payment Remittance Type Added Successfully", "success");
        }
      },
      onError: (error) => {
        toast.fire("Failed","Failed to Add Payment Remittance Type", "error");
      },
    }
  );

  return mutate;
};
export default useAddPaymentRemittanceType;
